import { render, staticRenderFns } from "./CvHighlights.vue?vue&type=template&id=39670b0d&"
import script from "./CvHighlights.vue?vue&type=script&lang=js&"
export * from "./CvHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports